<form #formRef="ngForm" class="flex-content">

    <!-- HEADER -->
    <div style="float:left;">
        <h2 mat-dialog-title><span translate>{{selectedReport.Name}}</span><span *ngIf="isForSchedule"> - Auto-Run Settings</span></h2>

    </div>

    <reportSettingsAutoRun *ngIf="isForSchedule"></reportSettingsAutoRun>


    <!-- CONTENT -->
    <mat-dialog-content>

          <table style="width:98%; margin-left:10px;" st-select-row="parameterRow" st-select-mode="single">

            <!-- *************** SEND TO EMAIL *************** -->

            <!-- [ngClass]="{'tableOddRow': !isEven($index +1), 'tableEvenRow': isEven($index +1)}" -->
            <tr *ngIf="MailServer > '' " style="width:100%;">

                <td colspan="2" style="padding-left: 0px;" *ngIf="true">


                    <!-- <mat-checkbox [(ngModel)]="selectedReport.SendToEmail">Send Report To Email(s)</mat-checkbox> -->

                    <tyl-checkbox *ngIf="!isForSchedule" [(checked)]="selectedReport.SendToEmail" id="SendToEmail_ID"
                        translate name="SendToEmail" (change)="sendToEmailChecked($event)">
                        Report to Email
                    </tyl-checkbox>

                    <div *ngIf="selectedReport.SendToEmail">
                        <!-- [pattern]="getEmailRegexp()" -->
                        <!-- Multiline Textboxes -->
                        <tyl-form-field label="Email From:" style="width: 100%;">
                            <textarea matInput [(ngModel)]="selectedReport.EmailFrom" name="EmailFrom" required
                                 [pattern]="getEmailRegexp()" autoComplete="off" autoCorrect="off"
                                autoCapitalize="off" spellCheck="false" maxLength="300" rows="1"
                                placeholder="Enter Email From">
                        </textarea>
                        </tyl-form-field>
                        <tyl-form-field label="Send to Email(s):" style="width: 100%;">
                            <textarea matInput [(ngModel)]="selectedReport.EmailsToSendReport" name="EmailsToSendReport"
                                required [pattern]="getEmailRegexp()" #emailsToSendReport autoComplete="off"
                                autoCorrect="off" autoCapitalize="off" spellCheck="false" maxLength="4000" rows="2"
                                placeholder="Enter email(s) to send this report">
                        </textarea>
                        </tyl-form-field>
                        <tyl-form-field *ngIf="!isForSchedule" label="Email Subject:" style="width: 100%;">
                            <textarea matInput [(ngModel)]="selectedReport.EmailSubject" name="EmailSubject" required
                                #emailSubject maxLength="2000" rows="1" placeholder="Enter email subject">
                        </textarea>
                        </tyl-form-field>
                        <tyl-form-field *ngIf="!isForSchedule" label="Email Body:" style="width: 100%;">
                            <textarea matInput [(ngModel)]="selectedReport.EmailBody" name="EmailBody" maxLength="500"
                                rows="1" placeholder="Enter email body">
                        </textarea>
                        </tyl-form-field>

                    </div>
                </td>

                <td *ngIf="selectedReport.ShowReportOptions && !selectedReport.SendToEmail" td width="20%"
                    style="padding-left: 0px;"></td>

            </tr>





        </table>


        <table style="width:98%; margin-left:10px; margin-top: 10px;" st-select-row="parameterRow"
            st-select-mode="single">

            <!-- PARAMETER ROWS-->
            <tr *ngFor="let parameterRow of ChunkedParameters.Rows" style="width:100%;" >

                <!-- Group start LINE WITHOUT HEADER -->
                <td *ngIf= "parameterRow.IsStartOfVisibleGroup && parameterRow.IncludeLineAtStartOfGroup && !parameterRow.IncludeGroupLabel" [colSpan] = "maxTableCellsPerRow" style= "border-bottom: 1px solid black; padding-top: 3px; padding-bottom: 3px;"></td>

                <!-- Group start LINE WITH HEADER -->
                <td *ngIf= "parameterRow.IsStartOfVisibleGroup && parameterRow.IncludeLineAtStartOfGroup && parameterRow.IncludeGroupLabel" [colSpan] = "maxTableCellsPerRow" style= "border-bottom: 1px solid black; padding-top: 3px; padding-bottom: 3px; font-weight: bold;">{{parameterRow.GroupLabel}}</td>

                <!-- Group start HEADER ONLY -->
                <td *ngIf= "parameterRow.IsStartOfVisibleGroup && !parameterRow.IncludeLineAtStartOfGroup && parameterRow.IncludeGroupLabel" [colSpan] = "maxTableCellsPerRow" style= "padding-bottom: 3px; padding-top: 3px; font-weight: bold;">{{parameterRow.GroupLabel}}</td>

                <!-- PARAMETER CELLS-->

                <!--  [style.width]="ParamColWidth" -->

                <td *ngFor="let parameter of parameterRow.Parameters" style="padding-left:10px; padding-right:10px; padding-bottom:10px;" valign="top"
                    [style.width]="getColumnWidth(parameter)"
                    [style.color]="parameter.HighlightParameter == true ? 'red' : null" [colSpan]="parameter.SpanNumberOfColumns"
                    [style.background-color]="parameter.SetBackgroundColorForSavedDefinition == true && !isForSchedule ? getBackgroundColorForSavedDefinition(parameter) : null">

                    <!-- *********************** START MAIN parameter CONTROLS CELL(S) IN ROW *********************** -->

                    <!-- TextBox -->

                    <tyl-form-field label="{{parameter.Name}}"
                        *ngIf="parameter.DataSource == null && (parameter.ControlType != 'rtxt' || !loginSettings.V10) && (parameter.DataType == 'varchar' || parameter.DataType == 'int')">
                        <input matInput  name="Txt{{parameter.Name}}+{{parameter.parameterId}}" [(ngModel)]="parameter.Value"
                            id="Txt{{parameter.ParameterName}}+{{parameter.parameterId}}"
                            placeholder="Enter {{parameter.Name}}" />
                    </tyl-form-field>

                    <!-- Multiline Textbox -->

                    <tyl-form-field *ngIf="parameter.DataSource == null && parameter.ControlType == 'rtxt'"
                        label="{{parameter.Name}}"
                        hint="{{parameter.MaxLength - parameter.Value.length}} characters left"
                        style='white-space: no-wrap;'
                    >
                        <textarea matInput
                            [(ngModel)]="parameter.Value"
                            id="Multi{{parameter.ParameterName}}+{{parameter.parameterId}}"  name="Multi{{parameter.Name}}+{{parameter.parameterId}}"
                            maxLength="parameter.MaxLength">
                        </textarea>

                    </tyl-form-field>
                    <span style="vertical-align: top">
                        <tyl-button style="vertical-align: top" *ngIf="parameter.ParameterName == '@Student_Numbers' "
                            image="menumystudents.png" (clickEvent)="studentSearchClick(parameter)"></tyl-button>
                    </span>


                    <!-- Date Picker-->

                    <ng-container *ngIf="(parameter.DataType == 'date' || parameter.DataType == 'datetime')"
                        style="display:inline;">
                        <tyl-datepicker label="{{parameter.Name}}" id="DatePicker{{parameter.ParameterName}}+{{parameter.parameterId}}"
                            [(value)]="parameter.Value">
                        </tyl-datepicker>
                    </ng-container>

                    <!-- Checkbox -->

                    <tyl-checkbox *ngIf="parameter.DataSource == null && parameter.DataType == 'bit'"
                        [(checked)]="parameter.Value" (change)="parameterChanged(parameter)"
                        id="Cb{{parameter.ParameterName}}+{{parameter.parameterId}}"  name="Cb{{parameter.Name}}+{{parameter.parameterId}}">
                        {{parameter.Name}}
                    </tyl-checkbox>


                    <!-- Checkbox List (NOT Show All)  && !parameter.ShowAll -->

                    <div *ngIf="parameter.ControlType == 'cbl'" style="display: flex;" [style.flex-direction] = "getFlexDirection(parameter)" [style.flex-wrap] = "getWrap(parameter)" >
                        <label>
                            {{parameter.Name}}
                        </label>
                        <!-- <div style="display: flex; flex-direction: column; flex-wrap: wrap "> -->
                        <div style="display: flex;" [style.flex-direction] = "getFlexDirection(parameter)" [style.flex-wrap] = "getWrap(parameter)">
                            <tyl-checkbox *ngFor="let dataItem of parameter.DataSource; let i = index"
                                [(checked)]="dataItem.IsSelected"
                                (change)="parameterChanged(parameter, $event, i)"
                                id="Cbl{{parameter.ParameterName}}+{{parameter.parameterId}}_{{i}}"  name="Cbl{{parameter.Name}}+{{parameter.parameterId}}_{{i}}">
                                {{dataItem.TextField}}
                            </tyl-checkbox>
                        </div>
                    </div>

                    <!-- THIS IS THE DISTRIBUTE BY EMAIL Checkbox List-->

                    <!-- <div *ngIf="parameter.ControlType == 'cbl' && parameter.ParameterName.toLowerCase() == '@distributebyemailoption'" style="display: flex;" [style.flex-direction] = "getFlexDirection(parameter)" [style.flex-wrap] = "getWrap(parameter)" >
                            <label>
                                {{parameter.Name}}
                            </label>
                            <div style="display: flex;" [style.flex-direction] = "getFlexDirection(parameter)" [style.flex-wrap] = "getWrap(parameter)">
                                <tyl-checkbox *ngFor="let dataItem of parameter.DataSource; let i = index"
                                    [(checked)]="dataItem.IsSelected" [value]="dataItem.ValueField"
                                    (change)="parameterChanged(parameter, $event, i)"
                                    id="Cbl{{parameter.ParameterName}}+{{parameter.parameterId}}_{{i}}"  name="Cbl{{parameter.Name}}+{{parameter.parameterId}}_{{i}}">
                                    {{dataItem.TextField}}
                                </tyl-checkbox>
                            </div>
                        </div> -->

                    <!-- Checkbox List WITH All -->
                    <!-- I have this intentionally commented out -->
                    <!-- (valueChange)="parameter.Value = $event" -->
                    <!-- <div *ngIf="parameter.ControlType == 'cbl' && parameter.ShowAll">
                    <tyl-checkbox-list
                        label="{{parameter.Name}}"
                        arrange = 'horizontal'
                        (change)="parameterChanged(parameter, $event)"
                        [labels]="parameter.getMultiValue_Labels()"
                        [values]="parameter.getMultiValue_StringValues()"
                        [ids]="parameter.getMultiValue_Ids()"
                    >
                    </tyl-checkbox-list>
                </div> -->


                    <!-- Dropdown List -->

                    <tyl-form-field *ngIf="parameter.ControlType == 'ddl'" label="{{parameter.Name}}">
                        <mat-select id="CbAll{{parameter.ParameterName}}+{{parameter.parameterId}}"  name="CbAll{{parameter.Name}}+{{parameter.parameterId}}"
                            [ngModel]="parameter.Value"
                            (ngModelChange)="parameter.Value = $event; ddlChange(parameter);"
                            matTooltip="{{parameter.Name}}">
                            {{parameter.Name}}
                            <mat-option *ngFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                                {{dataItem.TextField}}
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>


                    <!-- Dropdown Check Box List -->

                    <tyl-form-field label="{{parameter.Name}}" *ngIf="parameter.ControlType == 'ddcbl'">
                        <mat-select id="Ddcbl{{parameter.ParameterName}} + {{parameter.parameterId}}"   name="Ddcbl{{parameter.Name}}+{{parameter.parameterId}}+{{parameter.parameterId}}"
                            [(value)]="parameter.MultiValue" [(ngModel)]="parameter.MultiValue" multiple
                            placeholder="Please select...">
                            <mat-option *ngFor="let dataItem of parameter.DataSource"
                                (click)="ddbcblChanged(parameter, dataItem)" [value]="getBooleanValue(dataItem.ValueField)">
                                {{dataItem.TextField}}
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>


                        <tyl-form-field label="Post HS Institution" *ngIf="utilizeTranscriptTracking && parameter.ParameterName.toLowerCase() == '@post_hs_institution'">
                            <mat-select matTooltip="Post HS Institution">
                                <cdk-virtual-scroll-viewport [itemSize]="35" [style.height.px]=5*35 class="viewport" minBufferPx="200" maxBufferPx="400">
                                    <mat-option *cdkVirtualFor="let dataItem of parameter.DataSource" [value]="dataItem.ValueField">
                                        {{dataItem.TextField}}
                                    </mat-option>
                                </cdk-virtual-scroll-viewport>
                            </mat-select>
                        </tyl-form-field>


                    <!-- Radiobutton Lists -->

                    <!-- vertical radio button list-->

                    <div *ngIf="parameter.ControlType == 'rbl' && parameter.ShowOptionsVertically"
                        style='white-space: no-wrap; display: flex; align-content: flex-start;'>
                        <tyl-radio-group label="{{parameter.Name}}" arrange='vertical' [selected]="parameter.Value"
                            style="flex-direction: column"
                            (selectedChange)="parameter.Value = $event; parameterChanged(parameter, $event);"
                            [labels]="parameter.getMultiValue_Labels()"
                            [values]="parameter.getMultiValue_StringValues()" [ids]="parameter.getMultiValue_Ids()">
                        </tyl-radio-group>
                    </div>

                    <!-- horizontal radio button list-->

                    <div *ngIf="parameter.ControlType == 'rbl' && !parameter.ShowOptionsVertically"
                        style='white-space: no-wrap; display: flex; align-content: flex-start;'>
                        <tyl-radio-group label="{{parameter.Name}}" arrange='horizontal' [selected]="parameter.Value"
                            style="flex-direction: row"
                            (selectedChange)="parameter.Value = $event; parameterChanged(parameter, $event);"
                            [labels]="parameter.getMultiValue_Labels()"
                            [values]="parameter.getMultiValue_StringValues()" [ids]="parameter.getMultiValue_Ids()">
                        </tyl-radio-group>
                    </div>

                </td>

                <!-- GROUP END line  -->
                <td *ngIf= "parameterRow.IsEndOfVisibleGroup && parameterRow.IncludeLineAtEndOfGroup" colspan = "3" style= "border-top: 1px solid black; padding-bottom: 3px;"></td>

            </tr> <!-- END parameter row -->
        </table>

        <!-- DEBUG WINDOW -->
        <tyl-form-field *ngIf="isDebugModeInProduction  && debugMessage > ''"
        style='white-space: no-wrap; width: 100%;'
    >
        <textarea matInput
            [(ngModel)]="debugMessage"
            id="debugWindow"
            name="debugWindow"
            rows="12" disabled >
        </textarea>

    </tyl-form-field>



    </mat-dialog-content>


    <mat-dialog-actions>


        <!-- Footer -->

        <div class="flex-footer-left" style="align-items: center; width: 30%">

            <tyl-button *ngIf="useReportDefinitions && !isForSchedule" style="float:left; color: black;"
                image="Legend.png" label="Legend" (clickEvent)="legendClick()"></tyl-button>
            <mat-slide-toggle *ngIf="useReportDefinitions && !isForSchedule" [checked]="showHiddenParameters"
                (change)="showHiddenParametersChecked()" id="ShowHiddenParameters_ID" name="ShowHiddenParameters"
                translate>
                {{ hiddenParametersLabel }}
            </mat-slide-toggle>
            <mat-slide-toggle style="padding-left: 10px;" *ngIf="isForSchedule"
                [checked]="selectedReport.AutoRunReport"
                (change)="selectedReport.AutoRunReport = !selectedReport.AutoRunReport"
                [matTooltip]="isInFolder ? '' : 'Report must be in a folder to enable Auto-Run'" id="AutoRun_ID"
                name="AutoRunToggle" translate [disabled]="!isInFolder">
                Auto-Run
            </mat-slide-toggle>

            <!-- DEBUG MODE CHECKBOX -->
            <tyl-checkbox *ngIf="isTylerAdmin" [(checked)]="isDebugModeInProduction" id="isDebugModeInProduction_ID"
                name="isDebugModeInProduction" (change)="isDebugModeInProductionChecked($event)">
                Debug Mode
            </tyl-checkbox>

        </div>
        <div class="flex-footer-right" style="align-items: center; width: 70%">

            <!--SHOW QUERY STRING-->

            <tyl-button *ngIf="isDebugModeInProduction" style="float:left; color: black;" image="up arrow.png"
            label="Show Query String" (clickEvent)="getQueryString()"></tyl-button>

           <!-- REPORT TO CONSOLE -->

           <tyl-button *ngIf="showReportToConsole" style="float:right; color: black;" image="next arrow.png"
           label="Report To Console" (clickEvent)="SelectedReportToConsole()"></tyl-button>

            <!-- REPORT OPTIONS -->
            <tyl-button *ngIf="!selectedReport.SendToEmail && useReportDefinitions && !isForSchedule"
                style="float:right; color: black;" image="post.png" translate label="Report Options"
                (clickEvent)="reportOptionsClick()" matTooltip="Please select any values you want to save first">
            </tyl-button>


            <!-- ARCHIVE PDF -->
            <tyl-button *ngIf="!isForSchedule && !selectedReport.SendToEmail && selectedReport.ShowArchiveToPdfButton && showReportToPDF" style="float:right; color: black;"
            image="post.png" translate label="Archive PDF" (clickEvent)="archiveReportClick()"></tyl-button>


            <!-- DISTRIBUTE BY EMAIL -->
            <tyl-button *ngIf="!isForSchedule && !selectedReport.SendToEmail && showDistributebyEmail" style="float:right; color: black;"
            image="post.png" translate label="Distribute by Email" (clickEvent)="distributeByEmailClick()"></tyl-button>



            <!-- REPORT TO EXCEL -->
            <tyl-button
                *ngIf="!isForSchedule && !selectedReport.SendToEmail && !selectedReport.ShowReportOptions && showReportToPDF"
                style="float:right; color: black;" image="post.png" translate label="Report To Excel"
                (clickEvent)="runReport('EXCEL')"></tyl-button>

            <!-- REPORT TO PDF -->
            <tyl-button
                *ngIf="!isForSchedule && !selectedReport.SendToEmail && !selectedReport.ShowReportOptions && showReportToPDF"
                style="float:right; color: black;" image="post.png" translate label="Report To PDF"
                (clickEvent)="runReport('PDF')"></tyl-button>

            <!-- ERROR PROMPT -->
            <error-prompt [errorList]="errors"></error-prompt>

            <!-- REPORT TO EMAIL -->
            <tyl-button *ngIf="!isForSchedule && selectedReport.SendToEmail && !selectedReport.ShowReportOptions"
                style="float:right; color: black;" image="email button.png" translate label="Report to Email"
                (clickEvent)="runReportToEmail('PDF'); validationTrigger.click();"></tyl-button>

            <!-- SAVE AUTORUN REPORT -->
            <tyl-button *ngIf="isForSchedule" style="float:right; color: black;" image="post.png" translate label="Save"
                (clickEvent)="autoRunSaveClick()"></tyl-button>

            <!-- CANCEL REPORT TO EMAIL -->
            <tyl-button *ngIf="selectedReport.SendToEmail" style="float:right; color: black;" image="cancel.png"
                translate label="Cancel" (clickEvent)="cancelSendToEmailClick()"></tyl-button>

            <!-- CANCEL -->
            <tyl-button *ngIf="!selectedReport.SendToEmail && !selectedReport.ShowReportOptions && showReportToPDF"
                style="float:right; color: black;" image="cancel.png" translate label="Close"
                (clickEvent)="cancelShowReportParameters()"></tyl-button>

            <!-- HIDDEN BUTTON FOR FORM VALIDATION -->
            <input type="submit" form="ngForm" style="display: none" #validationTrigger>

        </div>

    </mat-dialog-actions>

</form>
